import { useState, useEffect } from 'react';
import { useMediaQuery } from '@mui/material';
import { ReactComponent as EfficiencyUpIcon } from '@Assets/graphUp.svg';
import { ReactComponent as EfficiencyDownIcon } from '@Assets/graphDown.svg';
import { ReactComponent as WorkloadUpIcon } from '@Assets/statUp.svg';
import { ReactComponent as WorkloadDownIcon } from '@Assets/statDown.svg';
import Skeleton from '@mui/material/Skeleton';
import '@Partials/_ComStyles.scss';
import '@Partials/_SimpleStyles.scss';
import '@Partials/_OverrideStyles.scss';
import './ProfileUserPerformance.scss';

export default function ProfileUserPerformance(props) {
    const [averageCompleted, setAverageCompleted] = useState(0);
    const [averageAssigned, setAverageAssigned] = useState(0);
    const [completedThisMonth, setCompletedThisMonth] = useState(0);
    const [assignedThisMonth, setAssignedThisMonth] = useState(0);
    const isMobile = useMediaQuery('(max-width: 768px)');
    const className = 'profileUserPerformance';

    useEffect(() => {
        if (!props.userAnalysisLoader) {
            parseData();
        }
    }, [props]);

    const parseData = () => {
        let monthVariableList = ['One', 'Two', 'Three', 'Four', 'Five', 'Six'];
        let totalAssignedValue = 0;
        let totalCompletedValue = 0;
        let zeroMonthsValue = 0;
        if (!!props.userAnalysis) {
            for (let i = 0; i < 6; i++) {
                const monthKey = 'userMonth' + monthVariableList[5 - i];
                const monthData = props.userAnalysis[monthKey];

                const monthCompleted = monthData?.completed || 0;
                const monthAssigned = monthData?.assigned || 0;

                totalCompletedValue += monthCompleted;
                totalAssignedValue += monthAssigned;

                if (monthCompleted + monthAssigned === 0) {
                    zeroMonthsValue += 1;
                }
            }
        }
        setCompletedThisMonth(props.userAnalysis?.userMonthOne?.completed || 0);
        setAssignedThisMonth(props.userAnalysis?.userMonthOne?.assigned || 0);
        const activeMonths = 6 - zeroMonthsValue;
        if (activeMonths > 0) {
            setAverageCompleted((totalCompletedValue / activeMonths).toFixed(2));
            setAverageAssigned((totalAssignedValue / activeMonths).toFixed(2));
        }
    };

    return (
        <div className={className}>
            {props.userAnalysisLoader ? (
                <div className={className + '__loader'}>
                    <div className={className + '__loader__card'}>
                        <Skeleton variant="circular" width={isMobile ? 56 : 48} height={isMobile ? 56 : 48} />
                        <div className={className + '__loader__text'}>
                            <Skeleton width={80} height={isMobile ? 28 : 24} />
                            <Skeleton width={60} height={isMobile ? 18 : 16} />
                        </div>
                    </div>
                    <div className={className + '__loader__card'}>
                        <Skeleton variant="circular" width={isMobile ? 56 : 48} height={isMobile ? 56 : 48} />
                        <div className={className + '__loader__text'}>
                            <Skeleton width={80} height={isMobile ? 28 : 24} />
                            <Skeleton width={60} height={isMobile ? 18 : 16} />
                        </div>
                    </div>
                </div>
            ) : (
                <div className={className + '__cards'}>
                    {/* Efficiency Card */}
                    <div className={className + '__card ' + (averageCompleted > completedThisMonth ? className + '__card--negative' : className + '__card--positive')}>
                        <div className={className + '__card__icon'}>
                            {averageCompleted > completedThisMonth ? <EfficiencyDownIcon /> : <EfficiencyUpIcon />}
                        </div>
                        <div className={className + '__card__content'}>
                            <div className={className + '__card__label'}>Efficiency</div>
                            <div className={className + '__card__value'}>
                                {
                                    !isNaN((((completedThisMonth - averageCompleted) / averageCompleted) * 100).toFixed(0))
                                        ? (averageCompleted > completedThisMonth ? '' : '+') + (((completedThisMonth - averageCompleted) / averageCompleted) * 100).toFixed(0) + '%'
                                        : '0%'
                                }
                            </div>
                            <div className={className + '__card__sublabel'}>vs 6-month avg</div>
                        </div>
                    </div>

                    {/* Workload Card */}
                    <div className={className + '__card ' + (averageAssigned > assignedThisMonth ? className + '__card--negative' : className + '__card--positive')}>
                        <div className={className + '__card__icon'}>
                            {averageAssigned > assignedThisMonth ? <WorkloadDownIcon /> : <WorkloadUpIcon />}
                        </div>
                        <div className={className + '__card__content'}>
                            <div className={className + '__card__label'}>Workload</div>
                            <div className={className + '__card__value'}>
                                {
                                    !isNaN((((assignedThisMonth - averageAssigned) / averageAssigned) * 100).toFixed(0))
                                        ? (averageAssigned > assignedThisMonth ? '' : '+') + (((assignedThisMonth - averageAssigned) / averageAssigned) * 100).toFixed(0) + '%'
                                        : '0%'
                                }
                            </div>
                            <div className={className + '__card__sublabel'}>vs 6-month avg</div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
